import {z} from 'zod';

import i18n from '@dms/i18n';

import {EMAIL_BODY_MAX_LENGTH} from '../constants/EMAIL_BODY_MAX_LENGTH';
import {isEmailHtmlEmpty} from './isEmailHtmlEmpty';
import {normalizeEmailHtml} from './normalizeEmailHtml';

/**
 * The two rules every e-mail body field carries.
 *
 * Both measure the normalized markup, which is what the API receives: it is longer than the raw
 * value, and it can be empty when the raw value was not — a pasted body holding only an image with
 * a refused source normalizes to nothing.
 */
export const refineEmailBody = <Schema extends z.ZodType<string | undefined>>(schema: Schema) =>
  schema
    .refine((body) => !isEmailHtmlEmpty(normalizeEmailHtml(body)), {
      message: i18n.t('errors.field_is_required'),
    })
    .refine((body) => normalizeEmailHtml(body).length <= EMAIL_BODY_MAX_LENGTH, {
      message: i18n.t('errors.field_is_too_long'),
    });
